/* LollyDoll · aperçu de la vignette au survol */
(function () {
  function brancher() {
    document.querySelectorAll('media-gallery.ll-thumb-hover').forEach(function (galerie) {
      if (galerie.dataset.llHover === '1') return;
      galerie.dataset.llHover = '1';
      var initial = null;
      galerie.querySelectorAll('.thumbnail-list__item').forEach(function (item) {
        var cible = item.getAttribute('data-target');
        if (!cible) return;

        function amener() {
          var colonne = galerie.querySelector('.thumbnail-slider');
          if (!colonne) return;
          if (colonne.scrollHeight <= colonne.clientHeight + 2) return;
          var r = item.getBoundingClientRect();
          var rc = colonne.getBoundingClientRect();
          var marge = 8;
          var delta = 0;
          if (r.bottom > rc.bottom) delta = (r.bottom - rc.bottom) + marge;
          else if (r.top < rc.top) delta = -((rc.top - r.top) + marge);
          if (delta === 0) return;
          var cible = Math.max(0, Math.min(colonne.scrollTop + delta,
                               colonne.scrollHeight - colonne.clientHeight));
          if (colonne.scrollTo) colonne.scrollTo({ top: cible, behavior: 'smooth' });
          else colonne.scrollTop = cible;
        }

        function montrer() {
          if (!initial) {
            var actif = galerie.querySelector('.product__media-item.is-active');
            initial = actif ? actif.getAttribute('data-media-id') : null;
          }
          amener();
          if (typeof galerie.setActiveMedia === 'function') galerie.setActiveMedia(cible, false);
        }
        /* Aperçu au survol : souris uniquement. Au doigt, il se déclenchait
           dès que l'on posait le doigt sur une vignette pour faire défiler la
           page : la photo changeait et le thème faisait défiler la galerie,
           ce qui annulait le geste. D'où le premier glissement sans effet sur
           mobile. Au doigt, c'est le tap qui change la photo, comme avant. */
        item.addEventListener('mouseenter', function () {
          if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          montrer();
        });
        item.addEventListener('focusin', function () {
          if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          montrer();
        });
        // un clic fige la sélection
        item.addEventListener('click', function () { initial = cible; });
      });
      galerie.addEventListener('mouseleave', function () {
        if (initial && typeof galerie.setActiveMedia === 'function') galerie.setActiveMedia(initial, false);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', brancher);
  document.addEventListener('shopify:section:load', brancher);
  brancher();
})();

/* LollyDoll · la colonne de vignettes ne dépasse jamais l'image principale */
(function () {
  function ajusterHauteur() {
    document.querySelectorAll('media-gallery.ll-thumbs-left, media-gallery.ll-thumbs-left-m').forEach(function (g) {
      var viewer = g.querySelector('[id^="GalleryViewer"]') ||
                   g.querySelector('slider-component:not(.thumbnail-slider)');
      var colonne = g.querySelector('.thumbnail-slider');
      if (!viewer || !colonne) return;
      var h = viewer.getBoundingClientRect().height;
      var enveloppe = colonne.closest('.ll-thumb-wrap');
      var val = h > 80 ? Math.round(h) + 'px' : '';
      if (enveloppe) {
        enveloppe.style.height = val;
        enveloppe.style.maxHeight = val;
        colonne.style.maxHeight = '';
      } else {
        colonne.style.maxHeight = val;
      }
    });
  }
  function surveiller() {
    ajusterHauteur();
    document.querySelectorAll('media-gallery .product__media-item img').forEach(function (img) {
      if (img.dataset.llH === '1') return;
      img.dataset.llH = '1';
      if (!img.complete) img.addEventListener('load', ajusterHauteur, { once: true });
    });
    if ('ResizeObserver' in window) {
      document.querySelectorAll('media-gallery [id^="GalleryViewer"]').forEach(function (v) {
        if (v.dataset.llRo === '1') return;
        v.dataset.llRo = '1';
        new ResizeObserver(ajusterHauteur).observe(v);
      });
    }
  }
  document.addEventListener('DOMContentLoaded', surveiller);
  window.addEventListener('load', ajusterHauteur);
  window.addEventListener('resize', ajusterHauteur);
  document.addEventListener('shopify:section:load', surveiller);
  surveiller();
})();



/* LollyDoll · chevrons de défilement de la colonne de vignettes
   La colonne est enveloppée dans un conteneur : les chevrons y sont ancrés
   et restent fixes pendant que la liste défile à l'intérieur. */
(function () {
  var CH_HAUT = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 12.5L10 7.5l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CH_BAS = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7.5l5 5 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function equiper() {
    document.querySelectorAll('media-gallery.ll-thumbs-left > .thumbnail-slider, media-gallery.ll-thumbs-left-m > .thumbnail-slider')
      .forEach(function (colonne) {
        if (colonne.dataset.llNav === '1') return;
        colonne.dataset.llNav = '1';

        var enveloppe = document.createElement('div');
        enveloppe.className = 'll-thumb-wrap';
        colonne.parentNode.insertBefore(enveloppe, colonne);
        enveloppe.appendChild(colonne);

        var haut = document.createElement('button');
        haut.type = 'button';
        haut.className = 'll-thumb-nav ll-thumb-nav--up';
        haut.setAttribute('aria-label', 'Voir les visuels précédents');
        haut.innerHTML = CH_HAUT;

        var bas = document.createElement('button');
        bas.type = 'button';
        bas.className = 'll-thumb-nav ll-thumb-nav--down';
        bas.setAttribute('aria-label', 'Voir les visuels suivants');
        bas.innerHTML = CH_BAS;

        enveloppe.appendChild(haut);
        enveloppe.appendChild(bas);

        function pas() {
          var item = colonne.querySelector('.thumbnail-list__item');
          var h = item ? item.getBoundingClientRect().height : 80;
          return Math.max(60, h + 12);
        }
        function glisser(sens) {
          var max = colonne.scrollHeight - colonne.clientHeight;
          var cible = Math.max(0, Math.min(colonne.scrollTop + sens * pas(), max));
          if (colonne.scrollTo) colonne.scrollTo({ top: cible, behavior: 'smooth' });
          else colonne.scrollTop = cible;
          setTimeout(rafraichir, 400);
        }
        haut.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); glisser(-1); });
        bas.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); glisser(1); });

        // défilement continu tant que la souris ou le doigt reste sur le chevron
        var minuteur = null;
        function demarrer(sens) {
          arreter();
          minuteur = setInterval(function () {
            var max = colonne.scrollHeight - colonne.clientHeight;
            var suivant = Math.max(0, Math.min(colonne.scrollTop + sens * 4, max));
            if (suivant === colonne.scrollTop) { arreter(); rafraichir(); return; }
            colonne.scrollTop = suivant;
            rafraichir();
          }, 16);
        }
        function arreter() { if (minuteur) { clearInterval(minuteur); minuteur = null; } }

        [[haut, -1], [bas, 1]].forEach(function (paire) {
          var bouton = paire[0], sens = paire[1];
          bouton.addEventListener('mouseenter', function () { demarrer(sens); });
          bouton.addEventListener('mouseleave', arreter);
          bouton.addEventListener('touchstart', function (e) { e.preventDefault(); demarrer(sens); }, { passive: false });
          bouton.addEventListener('touchend', arreter);
          bouton.addEventListener('touchcancel', arreter);
        });
        colonne.addEventListener('mouseleave', arreter);

        function rafraichir() {
          var debordement = colonne.scrollHeight > colonne.clientHeight + 2;
          haut.classList.toggle('is-on', debordement && colonne.scrollTop > 4);
          bas.classList.toggle('is-on', debordement && colonne.scrollTop < colonne.scrollHeight - colonne.clientHeight - 4);
          enveloppe.classList.toggle('has-nav', debordement);
        }
        colonne.addEventListener('scroll', rafraichir, { passive: true });
        window.addEventListener('resize', rafraichir);
        if ('ResizeObserver' in window) new ResizeObserver(rafraichir).observe(colonne);
        [250, 900, 1800].forEach(function (d) { setTimeout(rafraichir, d); });
      });
  }
  document.addEventListener('DOMContentLoaded', equiper);
  window.addEventListener('load', equiper);
  document.addEventListener('shopify:section:load', equiper);
  equiper();
})();

/* LollyDoll · la première vignette est active au chargement */
(function () {
  function marquer() {
    document.querySelectorAll('media-gallery').forEach(function (g) {
      var vignettes = g.querySelectorAll('.thumbnail');
      if (!vignettes.length) return;
      var deja = g.querySelector(".thumbnail[aria-current='true']");
      if (deja) return;
      var actif = g.querySelector('.product__media-item.is-active');
      var cible = null;
      if (actif) {
        var id = actif.getAttribute('data-media-id');
        var item = id ? g.querySelector('.thumbnail-list__item[data-target="' + id + '"]') : null;
        cible = item ? item.querySelector('.thumbnail') : null;
      }
      (cible || vignettes[0]).setAttribute('aria-current', 'true');
    });
  }
  document.addEventListener('DOMContentLoaded', marquer);
  window.addEventListener('load', marquer);
  document.addEventListener('shopify:section:load', marquer);
  marquer();
})();